<template>
  <div><h1>STUDENT DASHBOARD</h1></div>
</template>

<script>
export default {

}
</script>

<style>

</style>